import { render, staticRenderFns } from "./edit-ticket.vue?vue&type=template&id=08d5e216&"
import script from "./edit-ticket.vue?vue&type=script&lang=js&"
export * from "./edit-ticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports